export default __webpack_public_path__ + "static/media/rhenus-mad.6c86b822.svg";